import { render, staticRenderFns } from "./WowzaCredentials.vue?vue&type=template&id=bea4ba76&scoped=true&"
import script from "./WowzaCredentials.vue?vue&type=script&lang=js&"
export * from "./WowzaCredentials.vue?vue&type=script&lang=js&"
import style0 from "./WowzaCredentials.vue?vue&type=style&index=0&id=bea4ba76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea4ba76",
  null
  
)

export default component.exports